/* Jockey Australia — Phase 2 loader. Built from Phase-2-Rollout/src/loader-core.js by build.js. Do not edit here. */
var JK_GALLERY_CSS = "";
/*
 * Jockey Phase 2 PDP loader — core logic (shipped as poc-phase2-loader.js).
 *
 * Traffic splitting is NOT done here: Shopify Rollouts serves this theme to a share of visitors.
 * Whatever visitor is on this theme gets the changes. This file only does what Rollouts cannot:
 *   1. Honour a support switch (?poc_off=1) that shows the original page.
 *   2. Prevent a visible dropdown-to-tiles swap and, on NZ, a visible gallery re-layout.
 *   3. Hand the review settings to the feature scripts and load them, in order.
 * Any failure means "do nothing", so the shopper simply sees the original page.
 *
 * Reads its settings from window.__jkPdpCfg, written by the Liquid snippet:
 *   score        string review score, e.g. "4.75"
 *   count        string review count label, e.g. "12,000+"
 *   reviewsNote  bool   show the "no reviews yet" note beside the Reviews section (default on)
 *   expectTiles  bool   this product has 1-9 sizes (Liquid worked it out)
 *   gallery      bool   apply the 2x2 image grid (NZ only)
 *   wishlistPadding string  extra space above the Klaviyo "Add to favorites" button, e.g. "16px" (blank = leave as is)
 *   assets       array  absolute URLs of the feature scripts, load order
 *
 * The NZ image-grid CSS is not in the config: build.js writes it into the built file as
 * `var JK_GALLERY_CSS = "...";` ahead of this code (an empty string on AU).
 *
 * Support switch (never stored): ?poc_off=1  shows the original page on this theme.
 */
(function () {
  'use strict';
  var cfg = window.__jkPdpCfg;
  try {
    if (!cfg) return;
    if (/[?&]poc_off=1(?:&|$)/.test(String(location.search || ''))) return;

    window.JOCKEY_REVIEW_SUMMARY = { score: cfg.score, countLabel: cfg.count, emptyNote: cfg.reviewsNote !== false };

    var head = document.head || document.getElementsByTagName('head')[0];
    var de = document.documentElement;

    if (cfg.expectTiles) {
      // Hide the size dropdown until the tile script has run, so shoppers never see the
      // dropdown flash and then swap. The tile script removes the class as soon as its
      // first pass has run; the timer below is a failsafe if that script never loads.
      de.className += ' poc-tiles-pending';
      var guard = document.createElement('style');
      guard.textContent = 'html.poc-tiles-pending .product-detail__options .option-selector .custom-select{visibility:hidden}';
      head.appendChild(guard);
      setTimeout(function () {
        de.className = de.className.replace(/\s*poc-tiles-pending/g, '');
      }, 3000);
    }

    // Klaviyo's "Add to favorites" (wishlist) button: more space above it so it sits lower in the
    // buy box. content-box keeps the button's own 40px of height, so the extra padding adds
    // space above the heart instead of squeezing it toward the divider below. Only a plain
    // pixel value is accepted, so a bad setting can never inject other CSS.
    var wp = String(cfg.wishlistPadding || '');
    if (/^\d{1,3}px$/.test(wp) && parseInt(wp, 10) > 0) {
      var wish = document.createElement('style');
      wish.textContent = '[id*="klaviyo_email_marketing_sms_customer_hub_wishlist"] klaviyo-favorites-button button{box-sizing:content-box !important;padding-top:' + wp + ' !important}';
      head.appendChild(wish);
    }

    var galleryCss = typeof JK_GALLERY_CSS === 'string' ? JK_GALLERY_CSS : '';
    if (cfg.gallery && galleryCss) {
      // Pure CSS, injected now (before the page body paints) so the old image layout
      // never shows.
      var g = document.createElement('style');
      g.id = 'poc-gallery-grid-style';
      g.textContent = galleryCss;
      head.appendChild(g);
    }

    var assets = cfg.assets || [];
    for (var i = 0; i < assets.length; i++) {
      var s = document.createElement('script');
      s.src = assets[i];
      s.async = false; // keep source order
      head.appendChild(s);
    }
  } catch (err) {
    /* any failure = the original page */
  }
})();
